import { supabase } from '../supabaseClient';

// Snapshot of an order's editable fields, taken right before an edit is
// saved, so the system log can show what it looked like before the change.
export const snapshotOrderForLog = (order) => ({
  order_number: order.order_number,
  shipping_method: order.shipping_method,
  cod_amount: order.cod_amount,
  delivery_person: order.delivery_person,
  notes: order.notes,
  items: (order.order_items || []).map(
    (item) => `${item.products?.code || '—'} × ${item.quantity} @ ${item.price}`
  ),
});

// Fire-and-forget: logging should never block or break the action it's recording.
export const logAction = (currentUser, { action, entityType, entityId, description, oldData }) => {
  supabase
    .from('system_logs')
    .insert({
      user_id: currentUser?.id || null,
      action,
      entity_type: entityType || null,
      entity_id: entityId || null,
      description: description || null,
      old_data: oldData || null,
    })
    .then(({ error }) => {
      if (error) console.error('Error logging system action:', error);
    });
};
